export const introduce = {
  text: `### 使用方法
  + • 红色线：说明当前价格 > SF预测价格（价格/SF比值大于1），当前价格相对于SF模型被高估。
  + • 绿色线：说明当前价格 < SF预测价格（价格/SF比值小于1），当前价格相对于SF模型被低估。
  
  ### 指标原理
  + 当前价格与Stock-to-Flow预测价格之间的偏差幅度（当前价格/SF预测价格）`,
  height: 1320,
};
